<script>
import CommonRules from "@/mixins/CommonRules";
import VFormModified from "@/components/commonComponents/VFormModified.vue";
import AjaxLoad from "@/components/commonComponents/AjaxLoad.vue";
import UserAuth from "@/mixins/UserAuth";

export default {
    name: "WordCloudsWordsModal",
    components: {
        AjaxLoad,
        VFormModified,
    },
    mixins: [
        CommonRules,
        UserAuth,
    ],
    props: {
        idProject: {
            type: String,
        },
        idWordclouds: {
            type: [Number, String],
        },
    },
    data() {
        return {
            isShow: false,
            isResolved: false,
            isValid: false,
            isSubmit: false,
            wasModified: false,
            result: false,
            idWordcloudsWords: null,
            loadPromise: null,
            original: {},
            data: {},
            notifyOptions: {
                title: 'Облако смыслов',
            },
        };
    },
    computed: {
        isDisabled() {
            return this.isNew ?
                !this.user?.permissions?.byModule?.wordclouds?.canCreate :
                !(this.user?.permissions?.byModule?.wordclouds?.canUpdate && this.data?.permissions?.canUpdate);
        },
        isCanSubmit() {
            return !this.isDisabled && this.isValid && this.wasModified && !this.isSubmit && this.isResolved;
        },
        isNew() {
            return !this.idWordcloudsWords;
        },
        isLoading() {
            return !this.isResolved || this.isSubmit;
        },
        loadUrl() {
            return this.$apiUrl.getWordCloudWordUrl({
                id_project: this.idProject,
                id_wordclouds: this.idWordclouds,
                id_wordclouds_words: this.idWordcloudsWords,
            });
        },
        saveUrl() {
            return this.isNew ?
                this.$apiUrl.getWordCloudUrl({
                    id_project: this.idProject,
                    id_wordclouds: this.idWordclouds,
                }) :
                this.loadUrl;
        },
    },
    watch: {
        isShow(v) {
            if (!v) {
                this.resolve(this.result);
                this.result = false;
            }
        },
    },
    methods: {
        show(idWordcloudsWords, data = {}) {
            this.idWordcloudsWords = idWordcloudsWords;
            this.loadPromise = this.isNew ? Promise.resolve({data: {data}}) : this.$api.get(this.loadUrl);
            this.isShow = true;
            return new Promise((resolve, reject) => {
                this.resolve = resolve;
                this.reject = reject;
            });
        },
        onClickSave() {
            this.isSubmit = true;
            const method = this.isNew ? 'post' : 'put';
            this.$api[method](this.saveUrl, this.data)
                .then((response) => {
                    this.result = response;
                    this.notifySuccess('Успешно сохранено');
                    this.close();
                })
                .catch(this.notifyError)
                .finally(() => {
                    this.isSubmit = false;
                });
        },
        onClickCancel() {
            this.close();
        },
        close() {
            this.isShow = false;
        },
        isDisabledField(field) {
            return this.isNew ?
                !this.user?.permissions?.byModule?.wordclouds?.canCreate :
                !(this.user?.permissions?.byModule?.wordclouds?.canUpdate && this.data?.permissions?.isEditableField[field]);
        },
    },
}
</script>

<template>
    <v-dialog
        v-if="isShow"
        v-model="isShow"
        max-width="500px"
        :persistent="wasModified"
    >
        <ajax-load
            v-model="original"
            :promise="loadPromise"
            :transform="response => response.data.data"
            :resolved.sync="isResolved"
        >
            <v-form-modified
                v-model="isValid"
                :original="original"
                :modified.sync="data"
                :was-modified.sync="wasModified"
                @submit.prevent="onClickSave"
            >
                <v-card :loading="isLoading">
                    <v-card-title>{{ isNew ? 'Создание' : 'Редактирование' }}</v-card-title>
                    <v-card-text>
                        <v-container>
                            <v-row>
                                <v-col class="pa-0">
                                    <v-text-field
                                        v-model="data.text"
                                        :rules="[rules.required, rules.minLength(3)]"
                                        :disabled="isDisabledField('text')"
                                        label="Слово"
                                        class="required"
                                        autofocus
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="pa-0">
                                    <v-text-field
                                        v-model.number="data.value"
                                        :rules="[rules.nonNegativeInteger]"
                                        :disabled="isDisabledField('value')"
                                        label="Значение"
                                        class="required"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn @click="onClickCancel">
                            Отмена
                        </v-btn>
                        <v-btn
                            :disabled="!isCanSubmit"
                            color="primary"
                            type="submit"
                        >
                            Сохранить
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-form-modified>
        </ajax-load>
    </v-dialog>
</template>

<style scoped lang="scss">

</style>
